import {
  COMPARATIVE_NUMBER_IN_HOURS_10,
  SECONDS_PER_HOUR,
  SECONDS_PER_MINUTE
} from 'utils/constants/dateInfo/time-numbers';

export const fancyTimeFormat = (duration: number): string => {
  const hrs = ~~(duration / SECONDS_PER_HOUR);
  const mins = ~~((duration % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
  const secs = ~~duration % SECONDS_PER_MINUTE;

  let res = '';

  res += `${(hrs < COMPARATIVE_NUMBER_IN_HOURS_10 ? '0' : '') + hrs}:${
    mins < COMPARATIVE_NUMBER_IN_HOURS_10 ? '0' : ''
  }`;

  res += `${mins}:${secs < COMPARATIVE_NUMBER_IN_HOURS_10 ? '0' : ''}`;
  res += `${secs}`;

  return res;
};
